import React from "react";

import moment from "moment";

import { InputSwitch } from "primereact";

import { DeveloperCompanyModel } from "../../../../../domain/models/developer-company.model";
import { DeveloperProps } from "../../../../../domain/models/developer.model";

import { ItemField } from "../../../../components/datagrid";
import Icons from "../../../../components/icons-helper";
import ButtonRound from "../../../../components/button-action";

import { theme } from "../../../../styles/theme";
import { ContainerButtonActions } from "./styles";

import { makeRemoteDeveloper } from "../../../../../main/factories/usecases/developer/remote-developer-factory";
import { makeRemoteCompanies } from "../../../../../main/factories/usecases/companies/remote-companies-factory";

import { addEllipsis } from "../../../../helpers";
import { ListUserApprovedProps } from "../../../../../domain/models/list-user-approved.model";

const makeFields = (
  handleReload: () => void,
  setRemove: React.Dispatch<
    React.SetStateAction<DeveloperCompanyModel | undefined>
  >,
  history: any,
): ItemField[] => [
  {
    title: "ID",
    key: "id",
    renderItem: (data: DeveloperProps) => data?.id?.toString().padStart(3, "0"),
  },
  {
    title: "Desenvolvedor",
    key: "nameDeveloper",
    renderItem: (data: DeveloperProps) => {
      if (!data?.name) return "-";

      return addEllipsis(data?.name, 30);
    },
  },
  {
    title: "Plano",
    key: "plan",
    renderItem: (data: ListUserApprovedProps) => {
      if (!data.developerPackages?.length) return "-";
      const objectPackage = data.developerPackages.filter((item) => item.isActive === true);

      if(!objectPackage.length) {
        return "-";
      }
      const [ dataDeveloperPackage ] = objectPackage;

      const { pack } = dataDeveloperPackage;

      if(!pack?.packageEnum) return "-";

      return addEllipsis(pack.packageEnum, 30);
    },
  },
  {
    title: "Data Cadastro",
    key: "createdAt",
    renderItem: (data: DeveloperProps) => {
      if (data?.company) {
        return moment(data?.company?.createdAt).format("DD/MM/YYYY");
      }
      return "-";
    },
  },
  {
    title: "CNPJ/CPF",
    key: "cpf",
    renderItem: (data: DeveloperProps) => {
      if (data?.company) {
        return `${data?.company?.subscriptionNumber}`;
      }
      return `${data?.cpf}`;
    },
  },
  {
    title: "Razão Social",
    key: "name",
    renderItem: (data: DeveloperProps) => {
      if (!data?.company?.socialReason) return "-";

      return addEllipsis(data?.company?.socialReason, 30);
    },
  },
  {
    title: "Ativo",
    key: "actions",
    renderItem: (data: DeveloperProps) => (
      <InputSwitch
        checked={data?.enabled}
        onChange={async () => {
          if (data?.id) {
            await makeRemoteDeveloper().update(data.id, {
              ...data,
              enabled: !data.enabled,
            });
          }
          handleReload();
        }}
      />
    ),
  },
  {
    title: "Docs Emitidos",
    key: "actions",
    renderItem: (data: DeveloperProps) => (
      <ContainerButtonActions>
        {String(data?.countDocs)?.padStart(2, "0")}
        <ButtonRound
          backgroundColor={theme.colors.darkBlue}
          onClick={() =>
            history.push(`/admin/developers/documents/${data?.id}`)
          }
          title="Docs"
          color={theme.colors.lightBlue}
        >
          <Icons
            height={15}
            width={15}
            name="eye"
            color={theme.colors.lightBlue}
          />
        </ButtonRound>
      </ContainerButtonActions>
    ),
  },
  {
    title: "Ações",
    key: "action",
    renderItem: (data: DeveloperProps) => (
      <ContainerButtonActions>
        <ButtonRound
          backgroundColor={theme.colors.darkBlue}
          onClick={() => history.push(`/admin/developers/edit/${data?.id}`)}
          title="Editar"
          color={theme.colors.lightBlue}
        >
          <Icons
            height={15}
            width={15}
            name="edit"
            color={theme.colors.primary}
          />
        </ButtonRound>
        <ButtonRound
          backgroundColor={theme.colors.darkBlue}
          onClick={async () => {
            history.push(`/admin/developers/view/${data?.id ?? 0}`);
          }}
          title="Ver"
          color={theme.colors.green}
        >
          <Icons
            height={15}
            width={15}
            name="people"
            color={theme.colors.green}
          />
        </ButtonRound>
        <ButtonRound
          backgroundColor={theme.colors.darkBlue}
          onClick={async () => {
            if (data.company) {
              await makeRemoteCompanies().delete(data.company?.id);
            }
            setRemove(data);
          }}
          title="Excluir"
          color={theme.colors.red}
        >
          <Icons height={15} width={15} name="trash" color={theme.colors.red} />
        </ButtonRound>
      </ContainerButtonActions>
    ),
  },
];

export default makeFields;
